import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessagesService } from '@core/_services/messages.service';
import { replEmoji } from '@core/_utils/tools.utils';
import { ApiV6Service } from '@service/apiv6.service';
import { from, catchError, of, tap } from 'rxjs';

@Component({
    selector: 'commentaires',
    templateUrl: 'commentaires.component.html',
    styleUrls: ['commentaires.component.scss'],
})
export class CommentairesComponent implements OnInit {
    @Input() public scroll = false;
    @Input() public addComm = false;
    @Input() public addNotif = false;
    @Input() public userList = [];
    @Input() public displayUserList = true;    
    @Input() public docId = '';
    @Output()
    public onSave: EventEmitter<any> = new EventEmitter();
    @Output()
    public onComment: EventEmitter<any> = new EventEmitter();
    public commentaires = [];
    public comment;
    public destUser;
    public comboUser;
    public skeleton: boolean = true;
    public error: boolean = false;

    constructor(protected messageService: MessagesService, private translate: TranslateService, private api: ApiV6Service
    ) {
        this.comboUser = [];
    }

    ngOnInit(): void {
        this.initialize();
    }
    
    public ngOnChanges() {
        this.initialize();
        this.comboUser = [...this.userList];    
        this.returnData();
    }

    private initialize() {
        this.comment = '';
        this.skeleton = true;
        this.error = false;
    }

    private returnData() {
        if (this.docId !== '') {
            return from(this.api.getCommDoc(this.docId)).pipe(
                tap(result => {
                    this.commentaires = [...(result?.['CommentList']?.['Comment'] || [])];
                    this.error = false;
                    this.skeleton = false;
                }),
                catchError((error: any) => {
                    console.log(error);
                    this.error = true;
                    this.skeleton = true;
                    this.messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
                    return of(null); // Émet une valeur par défaut en cas d'erreur
                })
            ).subscribe();
        }
    }

    public async refresh() {
        this.initialize();
        await this.returnData();
    }

    public onOutComment() {
        this.comment = this.comment.trim();
        this.comment = replEmoji(this.comment, this.messageService, this.translate);
        if (this.comment !== '') {
            this.onComment.emit({                
                outComment: true,
                comment: this.comment,
            });
        }
    }
    
    public clickSaveComment() {
        let wDestUser = [];
        let wNotifMess = '';
        if (this.addNotif === true && this.comboUser.length !== 0 && (this.destUser !== undefined && this.destUser !== null) === true) {
            wDestUser = this.destUser;
            wNotifMess =  '';
        }
        this.comment = replEmoji(this.comment, this.messageService, this.translate);
        if (this.comment.trim() !== '') {
            this.onSave.emit({
                comment: this.comment,
                notif: {
                    destUser: wDestUser,
                    notifMess: wNotifMess,
                }
            });
            this.initialize();            
            this.destUser = null;
        }
    }

    public preventEmoji(event: KeyboardEvent) {
        const target = event.target as HTMLInputElement;
        target.value = replEmoji(target.value, this.messageService, this.translate);
    }
}
